import { takeEvery, put, call, fork } from "redux-saga/effects";
import { message } from "antd";
import { BucketListService } from "services";
import {
    fetchedBucketCases,
    failedFetchBucketCases,
    assignedBucketCases,
    failedAssignBucketCases,
    successProceedBucketCases,
    failedProceedBucketCases,
    successReferBucketCases,
    failedReferBucketCases,
    bulkAssignedBucketCases,
    failedBulkAssignBucketCases,
    fetchBucketCases
} from "actions";
// import { history } from "router";
import { BUCKET_LIST_ACTIONS } from "constants";


function* fetchBucketCasesHandler({payload: {stageIds, type, pageNo, pageSize, stage, caseStatus, filters, documentFilter}}) {
    try{
        const {data, error} = yield call(BucketListService.fetchBucketCases, stageIds, type, pageNo, pageSize, filters, documentFilter);
        if(!error) {
            yield put(fetchedBucketCases(stageIds, type, pageNo, data.results, data.count, stage, caseStatus, filters));
        } else {
            yield put(failedFetchBucketCases(error));
        }
    } catch(error) {
        if(error.response.status >= 500) {
            message.error("Internet Connectivity Issue. Try Again");
        } else {
            message.error("Failed to Fetch Cases");
        }
        yield put(failedFetchBucketCases(error));
    }
}

function* referBucketCases({payload: {case_task_id, this_stage, remarks}}) {
    try {
        const { data, error } = yield call(BucketListService.referCaseFromBucket, case_task_id, this_stage, remarks);
    
        if(!error) {
            yield put(successReferBucketCases(case_task_id, this_stage, data));
        } else {
            yield put(failedReferBucketCases(error));
        }
    } catch (error) {
        yield put(failedReferBucketCases(error));
    }
}

function* assignBucketCases({payload}) {
    try {
        const { data, error } = yield call(BucketListService.assignCaseFromBucket, payload.caseId);
        if(!error) {
            yield put(assignedBucketCases(payload.caseId, data));
        } else {
            yield put(failedAssignBucketCases(error));
        }
    } catch(error) {
        if(error.response.status >= 500) {
            message.error("Could not connect to server");
        }
        yield put(failedAssignBucketCases(error));    
    }
}

function* bulkAssignBucketCases({payload}) {
    try {
        const { data, error } = yield call(BucketListService.bulkCaseAssign, payload.caseTaskIds, payload.thisUser, payload.remarks);
        if(!error) {
            yield put(bulkAssignedBucketCases(payload.caseTaskIds, data));
            yield put(fetchBucketCases(JSON.stringify([payload.stageId]), "unassigned", 1, 50, payload.stageName, "INBOX"));
        } else {
            yield put(failedBulkAssignBucketCases(error));
        }
    } catch(error) {
        if(error.response.status >= 500) {
            message.error("Could not connect to server");
        }
        yield put(failedAssignBucketCases(error));
    }
}

function* proceedBucketCases({payload: {case_task_id, this_stage, remarks}}) {
    try {
        const { data, error } = yield call(BucketListService.proceedCaseFromBucket, case_task_id, this_stage, remarks);
    
        if(!error) {
            yield put(successProceedBucketCases(case_task_id, this_stage, data));
        } else {
            yield put(failedProceedBucketCases(error));
        }
    } catch (error) {
        yield put(failedProceedBucketCases(error));
    }
}

export default fork(function*() {
    yield takeEvery(BUCKET_LIST_ACTIONS.FETCH_CASE_BUCKET_LIST, fetchBucketCasesHandler);
    yield takeEvery(BUCKET_LIST_ACTIONS.REFER_BUCKET_CASE, referBucketCases);
    yield takeEvery(BUCKET_LIST_ACTIONS.PROCEED_BUCKET_CASE, proceedBucketCases);
    yield takeEvery(BUCKET_LIST_ACTIONS.ASSIGN_CASE_FROM_BUCKET, assignBucketCases);
    yield takeEvery(BUCKET_LIST_ACTIONS.BULK_ASSIGN_CASE_FROM_BUCKET, bulkAssignBucketCases);
});